<lib-modal-layout [title]="'Update Producer'" [subtitle]="''">
  @if (hasRetailAgentId) {
    <!-- Simple case: just select a producer from current agency -->
    <p class="text-center large">
      Use the dropdown below to reassign this submission to another producer in your agency.
    </p>
    <div class="flex flex-col items-center justify-center my-4 gap-4">
      <lib-form-dropdown
        class="w-3/5"
        [formControl]="producerId"
        [label]="'Agency User'"
        [placeholder]="'Select Agency User'"
        [options]="producers()"
      ></lib-form-dropdown>
    </div>
  } @else {
    <!-- Either/or case: select agency/producer OR provide adhoc info -->
    <p class="text-center large mb-4">
      Select an agency and producer from the dropdowns below <strong>OR</strong> provide agency/producer information manually.
    </p>

    <h4 class="mt-4 text-center">Option 1: Select from Existing Agencies</h4>
    <div class="flex flex-col items-center justify-center my-4 gap-4">
      <lib-form-dropdown
        class="w-3/5"
        [formControl]="agencyId"
        [label]="'Agency'"
        [placeholder]="'Select Agency'"
        [options]="agencies()"
      ></lib-form-dropdown>
      <lib-form-dropdown
        class="w-3/5"
        [formControl]="producerId"
        [label]="'Agency User'"
        [placeholder]="'Select Agency User'"
        [options]="producers()"
      ></lib-form-dropdown>
    </div>

    <h4 class="mt-[35px] text-center">Option 2: Provide Agency/Producer Information</h4>
    <p class="text-center mb-3 text-sm italic">These fields are disabled when an agency is selected above</p>

    <div [class.opacity-50]="adhocFieldsDisabled()" [class.pointer-events-none]="adhocFieldsDisabled()">
      <div class="w-full flex gap-[35px] px-4">
        <lib-form-text
          class="w-1/2"
          label="Agency Name"
          [formControl]="agencyName"
          maxlength="150"
        ></lib-form-text>
        <lib-form-text
          class="w-1/2"
          label="Producer Name"
          [formControl]="producerName"
          maxlength="150"
        ></lib-form-text>
      </div>

      <div class="w-full flex gap-[35px] px-4">
        <lib-form-text
          class="w-1/2"
          label="Primary Agency Address"
          [formControl]="agencyAddress1"
          maxlength="50"
        ></lib-form-text>
        <lib-form-text
          class="w-1/2"
          label="Suite"
          [formControl]="agencyAddress2"
          maxlength="50"
        ></lib-form-text>
      </div>

      <div class="w-full flex gap-[35px] px-4">
        <lib-form-text
          class="w-1/2"
          label="City"
          [formControl]="agencyCity"
          maxlength="64"
        ></lib-form-text>
        <div class="flex w-1/2 gap-[35px]">
          <lib-form-dropdown
            class="w-1/2"
            label="State"
            [options]="lookupStore.states()!"
            [placeholder]="'Select State'"
            [formControl]="agencyStateCode"
          ></lib-form-dropdown>
          <lib-form-text
            class="w-1/2"
            label="Zip Code"
            [formControl]="agencyZipCode"
            mask="99999"
            maxlength="10"
          ></lib-form-text>
        </div>
      </div>
    </div>
  }

  <p class="large text-center my-7">Submission documents will reflect this producer change.</p>
  
  <lib-button
    btnPrimary
    [cssType]="'btn-primary'"
    [text]="'Update Producer'"
    [type]="'submit'"
    [icon]="'rightarrow'"
    [disabled]="!isFormValid()"
    (click)="onSubmit()"
  ></lib-button>
</lib-modal-layout>